import { Product } from '../interfaces'
import { mockAdjustableBase, mockMattress } from './savedProduct'

/**
 * Mock Favorites session payload.
 */
export const mockSavedProducts: Product[] = [mockMattress, mockAdjustableBase]
